import { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router";

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

function useAutoHide(delay = 1000) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!visible) return;

        const timer = setTimeout(() => setVisible(false), delay);
        return () => clearTimeout(timer);
    }, [visible, delay]);

    return [visible, () => setVisible(true)];
}

export default function AddressForm({ }) {
    const { id } = useParams();
    const history = useHistory();
    const [showToast, triggerToast] = useAutoHide(2000);

    const [data, setData] = useState({ firstName: '', lastName: '', mobile: '', postalAddress: '' });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(id ? true : false);

    const { mobile, setPageTitle } = useContext(LayoutContext);

    useEffect(() => {
        setPageTitle(id ? 'ویرایش آدرس' : 'آدرس جدید');
    }, [id]);

    useEffect(() => {
        if (id) {
            fetch(getEndpoint(`/api/android/UserAddress/get?id=${id}`))
                .then(res => res.json())
                .then(data => {
                    setData(data.data);

                    setLoading(false);
                });
        }
    }, []);

    const handleChange = (e, propName) => {
        let value = e.target.value;

        if (propName === 'mobile') value = value.replace(/\D/g, '').slice(0, 11);

        setData(prev => ({
            ...prev,
            [propName]: value
        }));
    }

    const handleSubmit = e => {
        if (data.firstName === '' || data.lastName === '' || data.mobile === '' || data.postalAddress === '') {
            triggerToast();
            return;
        }

        fetch(getEndpoint("/api/android/UserAddress/submit"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: id,
                username: mobile,
                firstName: data.firstName,
                lastName: data.lastName,
                mobile: data.mobile,
                postalAddress: data.postalAddress
            })
        })
            .then(res => res.json())
            .then(data => {
                history.push('/checkout');
            });
    }

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='address p-5 d-f fd-c h-100'>
            <div>
                <div className="d-f ai-c br-2" style={{ boxShadow: '0 3px 6px rgba(0,0,0, .6)' }}>
                    <textarea className='bc-t w-100 p-2 f:o-n' placeholder='آدرس محل تحویل' onChange={e => handleChange(e, 'postalAddress')} value={data.postalAddress}></textarea>
                    <svg className='mx-2' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path fill='#9d9d9d' d="M16 13.781q1.375 0 2.344-0.969t0.969-2.344-0.969-2.344-2.344-0.969-2.344 0.969-0.969 2.344 0.969 2.344 2.344 0.969zM16 1.156q3.875 0 6.594 2.719t2.719 6.594q0 1.938-0.969 4.438t-2.344 4.688-2.719 4.094-2.281 3.031l-1 1.063q-0.375-0.438-1-1.156t-2.25-2.875-2.844-4.188-2.219-4.594-1-4.5q0-3.875 2.719-6.594t6.594-2.719z"></path>
                    </svg>
                </div>
                <div className="d-f ai-c br-2 mt-4" style={{ boxShadow: '0 3px 6px rgba(0,0,0, .6)' }}>
                    <input
                        className='bc-t w-100 p-2 f:o-n'
                        placeholder='شماره موبایل گیرنده'
                        type="text"
                        inputMode="numeric"
                        value={data.mobile}
                        onChange={e => handleChange(e, 'mobile')}
                        maxLength='11'
                    />
                    <svg className='mx-2' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path fill='#9d9d9d' d="M21.313 22.469v-18.688h-12v18.688h12zM15.313 27.781q0.813 0 1.406-0.594t0.594-1.406-0.594-1.406-1.406-0.594-1.406 0.594-0.594 1.406 0.594 1.406 1.406 0.594zM20.688-0.219q1.375 0 2.344 1t0.969 2.375v22.625q0 1.375-0.969 2.375t-2.344 1h-10.688q-1.375 0-2.344-1t-0.969-2.375v-22.625q0-1.375 0.969-2.375t2.344-1h10.688z"></path>
                    </svg>
                </div>
                <div className="d-f ai-c br-2 mt-4" style={{ boxShadow: '0 3px 6px rgba(0,0,0, .6)' }}>
                    <input className='bc-t w-100 p-2 f:o-n' placeholder='نام گیرنده' onChange={e => handleChange(e, 'firstName')} value={data.firstName} />
                    <svg className='mx-2' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path fill='#9d9d9d' d="M16 17.156q3.375 0 7.031 1.469t3.656 3.844v2.688h-21.375v-2.688q0-2.375 3.656-3.844t7.031-1.469zM16 14.469q-2.188 0-3.75-1.563t-1.563-3.75 1.563-3.781 3.75-1.594 3.75 1.594 1.563 3.781-1.563 3.75-3.75 1.563z"></path>
                    </svg>
                </div>
                <div className="d-f ai-c br-2 mt-4" style={{ boxShadow: '0 3px 6px rgba(0,0,0, .6)' }}>
                    <input className='bc-t w-100 p-2 f:o-n' placeholder='نام خانوادگی گیرنده' onChange={e => handleChange(e, 'lastName')} value={data.lastName} />
                    <svg className='mx-2' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path fill='#9d9d9d' d="M21.313 15.781q1.75 0 3.813 0.5t3.813 1.625 1.75 2.563v3.313h-8v-3.313q0-2.75-2.625-4.625 0.438-0.063 1.25-0.063zM10.688 15.781q1.75 0 3.813 0.5t3.781 1.625 1.719 2.563v3.313h-18.688v-3.313q0-1.438 1.75-2.563t3.813-1.625 3.813-0.5zM10.688 13.156q-1.625 0-2.813-1.188t-1.188-2.813 1.188-2.813 2.813-1.188 2.781 1.188 1.156 2.813-1.156 2.813-2.781 1.188zM21.313 13.156q-1.625 0-2.813-1.188t-1.188-2.813 1.188-2.813 2.813-1.188 2.813 1.188 1.188 2.813-1.188 2.813-2.813 1.188z"></path>
                    </svg>
                </div>
            </div>
            <button type='button' className='mt-a c-w br-4 _bc-g' style={{ height: '4.2rem' }} onClick={handleSubmit}>ثبت آدرس</button>

            {showToast && (
                <div className='toast p-f b-4 l-0 r-0 d-f jc-c'>
                    <div className='d-if px-5 py-3 br-999' style={{ backgroundColor: '#f0f0f0' }}>
                        ورود تمامی اطلاعات الزامی است!
                    </div>
                </div>
            )}
        </div>
    );
}